/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiAnalyticEventArtifactRecordingFromJSON, StreemApiAnalyticEventArtifactRecordingToJSON, } from './';
export function StreemApiAnalyticEventArtifactFromJSON(json) {
    return StreemApiAnalyticEventArtifactFromJSONTyped(json, false);
}
export function StreemApiAnalyticEventArtifactFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'artifactSid': !exists(json, 'artifact_sid') ? undefined : json['artifact_sid'],
        'roomSid': !exists(json, 'room_sid') ? undefined : json['room_sid'],
        'streemshot': !exists(json, 'streemshot') ? undefined : json['streemshot'],
        'mesh': !exists(json, 'mesh') ? undefined : json['mesh'],
        'gps': !exists(json, 'gps') ? undefined : json['gps'],
        'recording': !exists(json, 'recording') ? undefined : StreemApiAnalyticEventArtifactRecordingFromJSON(json['recording']),
        'sceneshot': !exists(json, 'sceneshot') ? undefined : json['sceneshot'],
        'layoutEstimation': !exists(json, 'layout_estimation') ? undefined : json['layout_estimation'],
        'recordingTrack': !exists(json, 'recording_track') ? undefined : json['recording_track'],
        'transcription': !exists(json, 'transcription') ? undefined : json['transcription'],
        'texturedMesh': !exists(json, 'textured_mesh') ? undefined : json['textured_mesh'],
        'bookmark': !exists(json, 'bookmark') ? undefined : json['bookmark'],
    };
}
export function StreemApiAnalyticEventArtifactToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'artifact_sid': value.artifactSid,
        'room_sid': value.roomSid,
        'streemshot': value.streemshot,
        'mesh': value.mesh,
        'gps': value.gps,
        'recording': StreemApiAnalyticEventArtifactRecordingToJSON(value.recording),
        'sceneshot': value.sceneshot,
        'layout_estimation': value.layoutEstimation,
        'recording_track': value.recordingTrack,
        'transcription': value.transcription,
        'textured_mesh': value.texturedMesh,
        'bookmark': value.bookmark,
    };
}
//# sourceMappingURL=StreemApiAnalyticEventArtifact.js.map